<script setup>
import { ref, computed } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { useEmitter } from 'dashboard/composables/emitter';
import { getUnixTime, addHours, addDays, addWeeks, addMonths } from 'date-fns';
import { CMD_SCHEDULE_MESSAGE } from 'dashboard/helper/commandbar/events';
import wootConstants from 'dashboard/constants/globals';
import CustomScheduleModal from 'dashboard/components/CustomScheduleModal.vue';

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();
const showCustomScheduleModal = ref(false);
const preDefinedScheduleTime = ref(null);

const selectedChat = computed(() => getters.getSelectedChat.value);
const contextMenuChatId = computed(() => getters.getContextMenuChatId.value);

const calculatePreDefinedTime = (scheduleType) => {
    const now = new Date();

    switch (scheduleType) {
        case wootConstants.SCHEDULE_OPTIONS.AN_HOUR_FROM_NOW:
            return addHours(now, 1);
        case wootConstants.SCHEDULE_OPTIONS.UNTIL_TOMORROW:
            return addDays(now, 1);
        case wootConstants.SCHEDULE_OPTIONS.UNTIL_NEXT_WEEK:
            return addWeeks(now, 1);
        case wootConstants.SCHEDULE_OPTIONS.UNTIL_NEXT_MONTH:
            return addMonths(now, 1);
        default:
            return null;
    }
};

const scheduleMessage = async (scheduleData) => {
    try {
        const conversationId = selectedChat.value?.id || contextMenuChatId.value;
        // Converter para string UTC ISO
        const scheduledAt = scheduleData.scheduleTime.toISOString();
        await store.dispatch('scheduleMessage', {
            conversationId,
            message: scheduleData.message,
            scheduledAt,
        });
        await store.dispatch('getConversation', conversationId);
        useAlert(t('COMMAND_BAR.COMMANDS.SCHEDULE_SUCCESS'));
    } catch (error) {
        useAlert(t('COMMAND_BAR.COMMANDS.SCHEDULE_ERROR'));
    }
    store.dispatch('setContextMenuChatId', null);
};

const onCmdScheduleMessage = scheduleType => {
    // Todas as opções de schedule devem abrir o modal customizado
    showCustomScheduleModal.value = true;

    // Se for uma opção predefinida, calcular a data/hora
    if (scheduleType !== wootConstants.SCHEDULE_OPTIONS.UNTIL_CUSTOM_TIME) {
        preDefinedScheduleTime.value = calculatePreDefinedTime(scheduleType);
        console.log('Pre-defined schedule time:', preDefinedScheduleTime.value);
    } else {
        preDefinedScheduleTime.value = null;
    }
};

const chooseScheduleTime = scheduleData => {
    showCustomScheduleModal.value = false;
    if (scheduleData && scheduleData.scheduleTime) {
        scheduleMessage(scheduleData);
    }
};

const hideCustomScheduleModal = () => {
    // if we select custom schedule and the custom schedule modal is open
    // Then if the custom schedule modal is closed then set the context menu chat id to null
    store.dispatch('setContextMenuChatId', null);
    showCustomScheduleModal.value = false;
};

useEmitter(CMD_SCHEDULE_MESSAGE, onCmdScheduleMessage);
</script>

<template>
    <woot-modal v-model:show="showCustomScheduleModal" :on-close="hideCustomScheduleModal">
        <CustomScheduleModal :pre-defined-time="preDefinedScheduleTime" @close="hideCustomScheduleModal"
            @choose-schedule="chooseScheduleTime" />
    </woot-modal>
</template>